import PaginationRequestData from '@/calendesk/models/DTO/Request/PaginationRequestData'

export default class UserSubscriptionsRequestData extends PaginationRequestData {

}
